export default "__VITE_ASSET__D94QdxcY__"